import { Controller } from "@hotwired/stimulus"

export default class HoroDailyController extends Controller {
  static targets = [
    "dayNumber",
    "dayName",
    "monthName",
    "year",
    "dateBtn",
    "eventIcons",
    "moonLabel",
    "panel"
  ]

  static values = { choosenBtnIndex: String }
  static outlets = ["modal"]

  connect() {
    this.dateBtn = this.element.querySelector(`button[data-index="${this.choosenBtnIndexValue}"]`)
    this.handleChoosenDate()
    if (this.hasModalOutlet) {
      this.modalOutlet.show()
    }
  }

  changeChoosenDateBtn(e) {
    this.dateBtn = e.currentTarget
    this.handleChoosenDate()
  }

  handleChoosenDate() {
    // สลับการ์ดคำทำนายของวันที่เลือก
    const index = this.dateBtn.dataset.index
    this.panelTargets.forEach(p => p.classList.toggle("hidden", p.dataset.index !== index))
    this.dayNumberTargets.forEach(t => t.textContent = this.dateBtn.dataset.dayNumber)
    this.dayNameTargets.forEach(t => t.textContent = this.dateBtn.dataset.dayName)
    this.monthNameTargets.forEach(t => t.textContent = this.dateBtn.dataset.monthName)
    this.yearTargets.forEach(t => t.textContent = this.dateBtn.dataset.year)
    this.clearHighlight(this.dateBtnTargets)
    this.clearEventIcons()
    this.addHighlight(this.dateBtn)
    this.showEventIcons()
    this.showMoonLabel()
  }

  showMoonLabel() {
    if (!this.hasMoonLabelTarget) return
    const emoji = this.dateBtn.dataset.moon || ""
    const lunar = this.dateBtn.dataset.lunar || ""
    this.moonLabelTarget.textContent = [emoji, lunar].filter(Boolean).join(" ")
  }

  addHighlight(target) {
    target.classList.add("highlight")
  }

  clearEventIcons() {
    // clear event icons on top page
    this.eventIconsTarget.innerHTML = ""

    // clear date btn icons
    this.dateBtnTargets.forEach(btn => {
      let dom = ""
      const eventDom = btn.querySelector(".btn-events")
      const events = JSON.parse(btn.dataset.eventsIcon)
      if (events.length > 0) {
        events.forEach(event => {
          dom += `<svg><use href="#icon-${event}-orange" /></svg>`
        })
      } else if (btn.dataset.moon) {
        dom = `<span class="moon-emoji">${btn.dataset.moon}</span>`
      } else {
        dom = `<svg><use href="#icon-วันปกติ-orange" /></svg>`
      }
      eventDom.innerHTML = ""
      eventDom.insertAdjacentHTML('beforeend', dom)
    })
  }

  clearHighlight(targets) {
    targets.forEach(t => t.classList.remove("highlight"))
  }

  showEventIcons() {
    const eventDom = this.dateBtn.querySelector(".btn-events")
    const eventsIcon = JSON.parse(this.dateBtn.dataset.eventsIcon)
    const eventsName = JSON.parse(this.dateBtn.dataset.eventsName)

    // show event chips (ไอคอนเล็ก + ชื่อย่อ แนวนอน) บนแถบวันที่ด้านบน
    eventsName.forEach((event, i) => {
      const topDom = `
        <div class="event-chip flex items-center gap-x-1">
          <svg><use href="#icon-${eventsIcon[i]}" /></svg>
          <span class="event-label">${event}</span>
        </div>
      `
      this.eventIconsTarget.insertAdjacentHTML('beforeend', topDom)
    })

    // show event icons on date btn
    let dom = ""
    if (eventsIcon.length > 0) {
      eventsIcon.forEach(event => {
        dom += `<svg><use href="#icon-${event}" /></svg>`
      })
    } else if (this.dateBtn.dataset.moon) {
      dom = `<span class="moon-emoji">${this.dateBtn.dataset.moon}</span>`
    } else {
      dom = `<svg><use href="#icon-วันปกติ" /></svg>`
    }
    eventDom.innerHTML = ""
    eventDom.insertAdjacentHTML('beforeend', dom)
  }
}